import CacheService from '../cache-service';
const axios = require('axios');

class DailyNewsService extends CacheService {
  getNewsById(id) {
    return this.getCachedData(`/api/daily-news/${id}`);
  }

  getNews(page = 1, tag) {
    const promise = this.getCachedData(`/api/daily-news?page=${page}${tag ? ('&tag=' + tag) : ''}`);
    // fetchAlsoTheNextPage
    this.getCachedData(`/api/daily-news?page=${page + 1}`);
    return promise;
  }

  postAutomatically(url) {
    const body = { newsUrl: url };
    return axios.post('/api/daily-news/auto-post', body).then(res => res.data);
  }

  addFuturePost(url) {
    const body = { newsUrl: url };
    return axios.post('/api/daily-news/future-post', body).then(res => res.data);
  }

  getSummarySinceId(id, format = 'json') {
    return axios.get(`/api/daily-news/summary?id=${id}&format=${format}`);
  }

  getFuturePosts() {
    return axios.get(`/api/daily-news/future-posts`).then(res => res.data);
  }

  saveFuturePosts(posts, dormosheioPosts, postsPerDay) {
    const body = { posts, dormosheioPosts, postsPerDay };
    return axios.post('/api/daily-news/future-posts', body);
  }

  delete(id) {
    return axios.delete(`/api/daily-news/${id}`);
  }

  getBatchManagerCandidates(queryParams) {
    return axios.get(`/api/daily-news/batch-manager${queryParams}`).then(res => res.data);
  }

  saveBatchManagerCandidates(candidates) {
    return axios.post('/api/daily-news/batch-manager', { candidates }).then(res => res.data);
  }    
}

const dailyNewsService = new DailyNewsService();

export default dailyNewsService;